// Croatian translations
export const hr = {
  // Common
  common: {
    home: 'Početna',
    settings: 'Postavke',
    language: 'Jezik',
    loading: 'Učitavanje...',
    save: 'Spremi',
    cancel: 'Odustani',
    confirm: 'Potvrdi',
    close: 'Zatvori',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Postavke',
    home: 'Početna',
    howToPlay: 'Kako igrati',
    pieceRules: 'Pravila figura',
    language: 'Jezik',
    manageSubscription: 'Upravljaj pretplatom',
    gameHistory: 'Povijest igara',
    analytics: 'Analitika',
    premiumAccount: 'Premium račun',
    chatEnabled: 'Chat: Uključen',
    chatDisabled: 'Chat: Isključen',
  },

  // Piece Rules
  pieceRules: {
    title: 'Pravila figura',
    description: 'Nauči kretanje figura',
    selectPiece: 'Odaberi figuru',
    selectedLabel: 'Odabrano:',
    statusLabel: 'Status:',
    statusReady: 'Spreman',
    statusViewing: 'Pregledavanje',
    movement: 'Kretanje',
    regularMovement: 'Obično kretanje',
    ability: 'Sposobnost',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Kretanje',
    savage: 'Divljački',
    birdtype: 'Ptičja vrsta',
    birdType: 'Ptičja vrsta',
    wallBlock: 'Blokada zida',
    moveblocks: 'Blokovi kretanja',
    wallclimb: 'Penjanje po zidu',
    lilypad: 'Lokvanj',
    poisonous: 'Otrovno',
    meadow: 'Livada',
    parasiticfungi: 'Parazitska gljiva',
    zombification: 'Zombifikacija',
    fungi: 'Gljiva',
    traverse: 'Prelaženje',
    capture: 'Hvatanje',
    faint: 'Onesvijest',
    leap: 'Skok',
    swing: 'Ljuljanje',
    consume: 'Konzumiranje',
    gamble: 'Kockanje',
    entangle: 'Zapetljavanje',
    ink: 'Tinta',
    rotate: 'Rotacija',
    backstep: 'Korak nazad',
    trample: 'Gaženje',
    charge: 'Napad',
    lane: 'Traka',
    snakestrike: 'Zmijski napad',
    shedskin: 'Odbacivanje kože',
    house: 'Kuća',
    plant: 'Biljna vrsta',
    planttype: 'Biljna vrsta',
    capturehost: 'Hvatanje domaćina',
    contagion: 'Zaraza',
    lonewolf: 'Usamljeni vuk',
    hop: 'Poskakivanje',
    decay: 'Raspadanje',
    slide: 'Klizanje',
    block: 'Blokada',
    poison: 'Otrov',
    infection: 'Infekcija',
    howl: 'Zavijanje',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Medvjed se može kretati jedno polje u bilo kojem smjeru, kao kralj u šahu',
    bearMovementPost: 'Blokiraju ga samo savezničke figure (osim Stabla, Medvjedi se mogu penjati po Stablima!)',
    bearSavage: 'Medvjed može savladati obrambene sposobnosti poput Nosororgovog Bloka',
    bearSavagePost: 'Koristeći Divljački, Medvjed može uhvatiti bilo koju figuru s bilo koje strane, dodajući smrtonosnost',

    // Crane
    craneMovement: 'Ždral se može kretati 1 ili 2 polja u bilo kojoj ravnoj liniji',
    craneMovementPost: 'Ždral može čak preletjeti preko drugih figura!',
    craneBirdType: 'Ptičje figure ne mogu uhvatiti velike ili grabežljive figure',
    craneBirdTypePost: 'To uključuje Stablo, Nosoroga, Medvjeda i Vuka',

    // Frog
    frogMovement: 'Žaba skače 2 polja dijagonalno',
    frogMovementPost: 'Ne može skočiti samo jedno',
    frogWallBlock: 'Ako je Žabin uobičajeni put od 2 polja blokiran zidom ili drugom figurom, ne može uhvatiti',
    frogWallBlockPost: 'Njeno uobičajeno kretanje je skraćeno na 1 polje dijagonalno',
    frogWallClimb: 'Kada je Žaba na zidu ploče (stupac A ili E), može se kretati gore ili dolje za jedno',
    frogWallClimbPost: 'Osim ako je blokirana savezničkom figurom ili Nosorogom ispred Žabe',
    frogLilypad: 'Ako se Žaba još nije pomakla u igri, može se kretati na bilo koji od prva 3 reda kao moćna obrambena sposobnost',
    frogLilypadPost: 'Može uhvatiti bilo koju običnu figuru koristeći Skok s lokvanja, osim Nosoroga na višem redu od sebe',
    frogPoisonous: 'Kada bilo koja životinja uhvati Žabu, postajete otrovna!',
    frogPoisonousPost: 'Otrovna figura preskače svoj sljedeći dostupni potez prije nego se oporavi',

    // Fungi
    fungiMovement: 'Gljiva se može kretati jedno polje u bilo kojem smjeru',
    fungiMovementPost: 'Blokiraju je samo savezničke figure',
    fungiMeadow: 'Gljiva smanjuje sposobnost kretanja neprijateljske figure Stablo',
    fungiMeadowPost: 'Neprijateljska figura Stablo ne može se kretati unutar 1 polja od Gljive',
    fungiParasitic: 'Gljiva može imobilizirati neprijateljsku figuru Stablo',
    fungiParasiticPost: 'Ako je Gljiva unutar 1 polja od neprijateljskog Stabla, ono se ne može kretati dok se Gljiva ne pomakne ili bude uhvaćena',
    fungiZombification: 'Gljiva može zombificirati bilo koju neprijateljsku životinju koja je uhvati, omogućujući kontrolu nad neprijateljskom životinjom za jedan potez',
    fungiZombificationPost: 'Zombificirana figura se također smatra Gljivom za taj potez, čak i ako je Gljiva bila vaš kralj, igra se ne završava dok se ne odigra taj potez',
    fungiFungi: 'Gljiva',
    fungiFungiPost: 'Poput otrova, zapetljavanja i virusne infekcije, ali ne zombifikacije jer može zombificirati druge!',

    // Goat
    goatMovement: 'Koza se može kretati jedno polje u bilo kojem smjeru',
    goatMovementPost: 'Koza se kreće polako, ali ima moćne sposobnosti',
    goatTraverse: 'Koza može prelaziti preko bilo kojih drugih povezanih figura kako bi stvorila ogroman potencijal kretanja',
    goatTraversePost: 'Koza ne može prelaziti preko Onesvještenih koza ili Sićušnih figura poput Virusa',
    goatCapture: 'Koza ne može uhvatiti nijednog Grabežljivca',
    goatCapturePost: 'Poput Medvjeda ili Vuka',
    goatFaint: 'Koza može onesvijestiti kako bi izbjegla hvatanje osim od velikih figura poput Stabla i Nosoroga',
    goatFaintPost: 'Dok je u nesvijesti, protivnici mogu "stajati" na onesvještenoj kozi kako bi zaustavili njeno kretanje',

    // Monkey
    monkeyMovement: 'Majmun se može kretati jedno polje u bilo kojem smjeru',
    monkeyMovementPost: 'Bez drugih figura za iskorištavanje, Majmun ima ograničeno kretanje',
    monkeyLeap: 'Majmun, kao igra dama, može skakati preko drugih figura u ravnoj liniji za ogroman potencijal kretanja',
    monkeyLeapPost: 'Ali ako skače preko neprijateljske figure, Majmun mora baciti kocku da preživi skok, šansa 1/6 za hvatanje za svakog neprijatelja preko kojeg skoči!',
    monkeySwing: 'Ako Majmun koristi skok preko Stabla, Majmun dobiva dodatni potez',
    monkeySwingPost: 'Korištenje ljuljanja na Stablu stvara moćnu sinergijsku kombinaciju između Majmuna i Stabla',
    monkeyConsume: 'Majmun može konzumirati Gljivu za dodatni potez',
    monkeyConsumePost: 'Vodeći do razornih kombinacija kada se kombinira s drugim dodatnim potezima',
    monkeyGamble: 'Osim bacanja kocke da skoči preko neprijatelja, Majmun se mora kockati da uhvati Medvjeda',
    monkeyGamblePost: 'Majmun mora baciti 5 ili 6 na kocki sa 6 strana da uhvati Medvjeda ili biva uhvaćen',

    // Octopus
    octopusMovement: 'Hobotnica se kreće jedno polje u bilo kojem smjeru',
    octopusCapture: 'Hobotnica može uhvatiti samo ortogonalno',
    octopusCapturePost: 'Hobotnica može uhvatiti ili zapetljati figure na složene načine pa uvijek provjerite crvena hvatanja i ljubičasta zapetljavanja!',
    octopusEntangle: 'Hobotnica može zapetljati susjedne neprijateljske figure, imobilizirajući ih, može čak preći polje i zapetljati neprijatelje!',
    octopusEntanglePost: 'Zapetljane figure se ne mogu kretati dok se Hobotnica ne pomakne ili bude uhvaćena',
    octopusInk: 'Hobotnica može koristiti tintu za bijeg iz opasnih situacija, stvarajući do 3 sjene',
    octopusInkPost: 'Zbunjujući neprijatelja i omogućujući zanimljive mamljive i izbjegavajuće poteze',

    // Penguin
    penguinMovement: 'Pingvin klizi u ravnoj liniji u svojem postavljenom smjeru dok zid ili figura ne blokira njegovo kretanje',
    penguinMovementPost: 'Nakon kretanja, Pingvin može unutar istog poteza postaviti svoj završni smjer također',
    penguinRotate: 'Na početku utakmice Pingvin gleda prema dolje i mora se rotirati prije nego što može kliziti, također poznato kao spavanje',
    penguinRotatePost: 'Pingvin u bilo kojoj poziciji može odabrati rotirati umjesto kretanja',
    penguinBirdType: 'Pingvin ima ograničene sposobnosti hvatanja, kao Ždral, ne može uhvatiti velike ili grabežljive figure poput Stabla, Nosoroga, Medvjeda ili Vuka',
    penguinBirdTypePost: 'Nakon hvatanja, Pingvin se može rotirati prema bilo kojem smjeru za strateško pozicioniranje',

    // Rhino
    rhinoMovement: 'Nosorog se kreće dva polja naprijed samo',
    rhinoMovementPost: 'Ne može se kretati samo 1 polje',
    rhinoBackStep: 'Nosorog se može kretati nazad-lijevo ili nazad-desno',
    rhinoCharge: 'Nosorog jednom po igri može putovati jedno dodatno polje naprijed koristeći svoju sposobnost napada',
    rhinoChargePost: 'Vodeći do razornog kretanja i potencijala hvatanja',
    rhinoTrample: 'Nosorog hvata sve figure na svom putu s Gaženjem',
    rhinoTramplePost: 'Uključujući onesvještenu Kozu',
    rhinoLane: 'Nosorog može zamijeniti mjesta s drugom savezničkom figurom omogućujući stratešku igru traka',
    rhinoLanePost: 'Ali samo ako se Nosorog i savezničke figure nisu kretali',

    // Snake
    snakeMovement: 'Zmija se može kretati 2 polja u bilo kojoj ravnoj liniji',
    snakeMovementPost: 'Zmija se kreće točno 2 polja osim ako je blokirana zidom ili savezničkom figurom',
    snakeMoveBlocks: 'Kada je blokirana zidom ili figurom koju ne može uhvatiti, Zmijino kretanje je skraćeno na 1 polje',
    snakeMoveBlocksPost: 'Može se i dalje kretati dva polja čak i ako postoji posrednička figura',
    snakeStrike: 'Zmija može udariti 3 polja naprijed ako postoji neprijateljska životinja',
    snakeStrikePost: 'Sve dok posredničke figure ne blokiraju njezin put',
    snakeShedskin: 'Jednom po igri, Zmija može odbaciti kožu i vratiti se u prvi red ako je polje slobodno',
    snakeShedskinPost: 'Ovo ponovno rođenje daje Zmiji dodatni život svake igre',

    // Tree
    treeMovement: 'Stablo se može kretati jedno polje naprijed ili na bilo koje polje na svom redu sa strane na stranu',
    treeMovementPost: 'Sve dok mu put nije blokiran',
    treeHouse: 'Stablo može smjestiti druge figure, štiteći ih od neprijatelja koji se ne mogu penjati po Stablima. Možda se figure mogu penjati kao Medvjed, Ždral, Žaba, Gljiva, Koza, Majmun, Hobotnica i Zmija',
    treeHousePost: 'Kada figura koja se može penjati po Stablu napadne, hvata samo smještenu figuru, štiteći Stablo',
    treeTrample: 'Stablo kao Nosorog, hvata sve figure na polju kada se kreće',
    treeTramplePost: 'To uključuje onesvještenu Kozu',
    treePlant: 'Stablo je biljka, a ne životinja, pa je imuno na nekoliko efekata',
    treePlantPost: 'Poput otrova, zombifikacije, zapetljavanja i virusne infekcije!',

    // Virus
    virusMovement: 'Virus se može kretati samo na polja zauzeta životinjama, koja su udaljena dva polja',
    virusMoveBlocks: 'Virus se može kretati samo jedno polje ako je pored zida',
    virusCaptureHost: 'Kada Virus sleti na (u) bilo koju životinju, samo je zaražava, mogu i dalje nastaviti redovnu igru dok su zaraženi',
    virusCaptureHostPost: 'Virus hvata figuru samo kada napusti zaraženog domaćina',
    virusContagion: 'Virus se može brzo širiti zarađujući više domaćina u jednom potezu',
    virusContagionPost: 'Zaraza omogućava Virusu da napravi koliko god legalnih poteza želi svaki potez',

    // Wolf
    wolfMovement: 'Vuk se može kretati u obliku L, kao konj u šahu',
    wolfMovementPost: 'Nije ometano drugim figurama',
    wolfLoneWolf: 'Vuk',
    wolfLoneWolfPost: 'Vuk također smatra sebe usamljenim kada još uvijek ima onesvještenu Kozu ili saveznika Virusa',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Povucite za istraživanje • Stisnite za zumiranje',
    dragToExploreDesktop: '🖱️ Povucite za istraživanje • Skrolajte za zumiranje',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Natrag',
    next: 'Dalje',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'TESTNO OKRUŽENJE',
    description: 'Eksperimentiraj i vježbaj',
    mode: 'Način:',
    modeValue: 'Testno okruženje',
    status: 'Status:',
    statusReady: 'Spreman',
    clearBoard: 'Očisti ploču',
  },

  // Multiplayer
  multiplayer: {
    title: 'VIŠEIGRAČ',
    description: 'Pronađi protivnika i natječi se!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Plasirni mečevi',
    matchProgress: 'Napredak meča',
    gamesCompleted: '{games} / 10 Odigranih igara',
    estimatedFinalRating: 'Procijenjeni završni rejting',
    startingRating: 'Početni rejting',
    matchesRemaining: '{matches} preostalih mečeva',
    findPlacementMatch: 'Pronađi plasirni meč',

    // Matchmaking modes
    findMatch: 'Pronađi meč',
    competitive: 'Natjecateljski',
    competitiveDesc: 'Pronađi protivnike blizu tvog ranga',
    quick: 'Brzo',
    quickDesc: 'Pronađi natjecateljske mečeve brzo',
    casual: 'Ležerno',
    casualDesc: 'Bez ranga - igraj za zabavu!',
    placement: 'Plasman',
    placementDesc: 'Završi 10 mečeva za rang',
    startSearch: 'Pokreni pretragu',

    // Searching
    searching: 'Pretraživanje...',
    mode: 'Način:',
    inQueue: 'U redu:',
    players: 'igrač',
    playersPlural: 'igrača',
    cancelSearch: 'Otkaži pretragu',

    // Game info
    status: 'Status:',
    ready: 'Spreman',
    selectingKing: 'Odabir kralja',
    placingPieces: 'Postavljanje figura',
    playing: 'Igranje',
    gameType: 'Vrsta igre:',
    opponent: 'Protivnik:',
    opponentElo: 'Protivnički ELO:',
    unranked: 'Bez ranga',

    // Piece placement
    dragPieces: 'Povuci figure na ploču',
    lightPieces: 'Svijetle figure (Ti)',
    darkPieces: 'Tamne figure (Ti)',

    // Waiting states
    waitingForOpponent: 'Čekanje protivnika...',
    waitingForKing: 'Čekanje da protivnik odabere svog kralja...',

    // Warnings
    invalidPlacement: 'Neispravno postavljanje',
    lightTurn: 'Red je Svijetlog igrača!',
    darkTurn: 'Red je Tamnog igrača!',
    onlyLightPieces: 'Možeš postaviti samo svijetle figure!',
    onlyDarkPieces: 'Možeš postaviti samo tamne figure!',
    mustPlaceOnRow: '{color} figure moraju biti postavljene na red {row}!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Upiši poruku...',
    send: 'Pošalji',
  },

  // Main Page
  mainPage: {
    title: 'ŽIVOTINJSKI ŠAH',
    subtitle: 'Igra za ljude',
    playersOnline: 'Trenutno aktivnih igrača',
    placement: 'Plasiranje',
    placementProgress: 'Plasiranje',
    challengeAI: 'Izazovi AI',
    multiplayer: 'Višeigrač',
    sandbox: 'Testno okruženje',
    tutorials: 'Vodiči',
    shop: 'Trgovina',
    collection: 'Kolekcija',
    history: 'Povijest',
    analytics: 'Analitika',
    courses: 'Tečajevi',
    upgradeAccount: 'Nadogradi račun',
    signIn: 'Prijavi se',
    playAsGuest: 'Igraj kao gost',
    welcomeBack: 'Dobrodošao natrag! Obično igraš kao',

    // Learn the Pieces section
    learnThePieces: 'Nauči figure',

    // Learn the Rules section
    learnTheRules: 'Nauči pravila',
    premiseTitle: 'Premisa',
    premiseText: 'Zodiac je alternativa šahu sa SKRIVENIM kraljem iz popisa od 13 figura, odaberi jedinstveni popis i zatim blefaj protivnika da bi ga pobijedio na 5 x 8 ploči',
    selectionTitle: 'Odabir',
    selectionText: 'Za početak igre, tajno odaberi svog kralja, zatim postavi svojih 5 figura naizmjenično s protivnikom kako bi stvorio jedno od preko 500 milijardi početnih stanja.',
    objectiveTitle: 'Cilj',
    objectiveText: 'Ili pročitaj protivnika da UHVATIŠ njegovog tajnog kralja ili UTRČI svog kralja preko ploče da osiguraš pobjedu!',
    competeTitle: 'Natječi se',
    competeText: 'Testiraj svoje vještine na ljestvici, razvij nove osobne tehnike i strategije, rangiraj se da se suočiš s najboljima!',
    fullRulesButton: 'Za potpuna službena pravila klikni ovdje',

    // FAQ section
    faqTitle: 'Često postavljana pitanja',
    faqQuestion1: 'Koja je ideja iza Zodiac šaha?',
    faqAnswer1: 'Zodiac šah je inspiriran riječima Bobbyja Fischera o njegovoj inspiraciji za stvaranje Šaha960, željeli smo proširiti ideju borbe protiv pamćenja napamet i slaviti ljudsku intuiciju u nesagledivoj dubini!',
    faqQuestion2: 'Zašto nam treba alternativa šahu',
    faqAnswer2: 'Ne treba! Zodiac ne želi odvratiti ljude od igranja šaha! To je različita opcija sa svojim prednostima i manama, nadamo se da ćete se zabaviti s njim i pomoći nam prilagoditi ovu igru kako bi obogatili novu igru',
    faqQuestion3: 'Kako pobjeđuješ u Zodiac šahu?',
    faqAnswer3: 'Postoje tri načina za pobjedu: uhvati protivnikovu skrivenu figuru kralja, utrči svog kralja na suprotnu stranu ploče, ili u meču s vremenskim kontrolama, neka protivnikovo vrijeme istekne',
    faqQuestion4: 'Je li ovo FAQ?',
    faqAnswer4: 'Da, možeš pogledati bilo koje od navedenih pitanja u FAQ-u i ako želiš više detalja, možeš kliknuti na pitanja i zatim pročitati sljedeće detalje, kao ove detalje koje sada čitaš',
    faqQuestion5: 'Koliko dugo traje tipična igra?',
    faqAnswer5: 'Svaka igra se razlikuje! Neke igre su gotove u 2 poteza, a neke mogu potrajati 30 minuta, obično imaju tendenciju biti u rangu od 5-15 minuta!',
    faqQuestion6: 'Što se događa ako nitko ne može napraviti legalan potez?',
    faqAnswer6: 'Ako igrač ne može napraviti nijedan legalan potez (pat pozicija), igra završava neriješeno. Igra također može završiti neriješeno ponavljanjem (isto stanje ploče 3 puta) ili uzajamnim dogovorom između igrača!',

    // About section
    aboutButton: 'O igri',
    privacyPolicy: 'Politika privatnosti',
    developerInterface: 'Razvojno sučelje',
  },

  // About Modal
  about: {
    title: 'O Zodiac-u',
    paragraph1: 'Zodiac je šahovska stolna igra koja kombinira elemente odabira figura iz igara poput LoL-a i DotA-e, s mehanikom blefiranja iz pokera ili društvenih igara dedukcije.',
    paragraph2: 'Rane verzije igre stvorene su 2014., pod nazivom Shadow Chess. 2018. je redizajnirana u ono što vidite danas, uključujući popis zabavnih figura s uravnoteženim, ali jedinstvenim uzorcima kretanja i sposobnostima.',
    paragraph3: 'Naša vizija je snimati sve podatke o igranju korisnika kako bismo nastavili razvijati igru u nastojanju da održimo igru osvježavajućom, potičući nove poteze.',
    paragraph4: 'S Zodiacovim ogromnim prostorom pretraživanja, skrivenim informacijama i otvarajućim pozicijama ploče nadamo se da ćemo spriječiti dominaciju AI-a i zadržati zodiac igrom za ljude!',
  },

  // Privacy Policy
  privacy: {
    title: 'Politika privatnosti',
    lastUpdated: 'Zadnje ažurirano',

    introduction: {
      title: 'Uvod',
      p1: 'Dobrodošli u Zodiac Chess ("mi," "naš," ili "nas"). Predani smo zaštiti vaše privatnosti i osiguravanju sigurnog i ugodnog iskustva igranja. Ova Politika privatnosti objašnjava kako prikupljamo, koristimo, otkrivamo i čuvamo vaše podatke kada koristite našu web stranicu i igru.',
      p2: 'Korištenjem Zodiac Chess-a pristajete na prikupljanje i korištenje podataka u skladu s ovom politikom. Ako se ne slažete s našim politikama i praksama, molimo vas da ne koristite našu uslugu.',
      contact: 'Kontaktirajte nas na:',
    },

    infoCollect: {
      title: 'Podaci koje prikupljamo',
      accountInfo: {
        title: '1. Podaci o računu',
        item1: 'Email adresa: Potrebna za stvaranje računa i komunikaciju',
        item2: 'Korisničko ime: Vaše odabrano prikazno ime',
        item3: 'Lozinka: Kriptirana i sigurno pohranjena',
      },
      gameData: {
        title: '2. Podaci o igri',
        item1: 'Statistika igre: Pobjede, porazi, ELO rejting, napredak plasmana',
        item2: 'Podaci o igranju: Odabiri figura, napravljeni potezi, korištene strategije',
        item3: 'Povijest mečeva: Zapisi odigranih igara, suočenih protivnika',
        item4: 'Kupnje u igri: Kozmetički predmeti i status premium članstva',
      },
      technicalData: {
        title: '3. Tehnički podaci',
        item1: 'Informacije o uređaju: Vrsta preglednika, operativni sustav',
        item2: 'Podaci o korištenju: Posjećene stranice, provedeno vrijeme, korištene značajke',
        item3: 'Lokalna pohrana: Jezične preferencije, UI postavke, privremeno stanje igre',
      },
    },

    children: {
      title: 'Privatnost djece (COPPA usklađenost)',
      p1: 'Zodiac Chess je dizajniran da bude prikladan za obitelj i pogodan za igrače svih dobi, uključujući djecu. Posebnu pažnju posvećujemo usklađivanju sa Zakonom o zaštiti privatnosti djece na internetu (COPPA).',
      p2: 'Za korisnike mlađe od 13 godina: Preporučujemo da djeca koriste naš gostinski način igranja, koji ne zahtijeva stvaranje računa ili prikupljanje podataka. Gostinski računi nemaju pristup značajkama chat-a, osiguravajući da djeca nisu izložena komunikaciji s širim internetom. Ako dijete stvori račun, zahtijevamo roditeljsku suglasnost prije prikupljanja bilo kakvih osobnih podataka.',
      p3: 'NE prikupljamo svjesno, koristimo ili dijelimo osobne podatke djece mlađe od 13 godina bez potvrđene roditeljske suglasnosti.',
      p4: 'Sigurnost chata: Tekstualni chat je automatski onemogućen za sve gostinske/privremene račune. Vlasnici standardnih računa imaju mogućnost onemogućiti funkcionalnost chata u postavkama računa u bilo kojem trenutku.',
      parentalRights: 'Roditelji imaju pravo:',
      right1: 'Pregledati osobne podatke svog djeteta',
      right2: 'Zatražiti brisanje podataka svog djeteta',
      right3: 'Odbiti daljnje prikupljanje ili korištenje podataka svog djeteta',
      contactUs: 'Da biste ostvarili ova prava ili ako vjerujete da nam je vaše dijete pružilo osobne podatke, molimo vas da nas odmah kontaktirate na contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Kako koristimo vaše podatke',
      item1: 'Pružamo i poboljšavamo naše usluge igre',
      item2: 'Uparivamo vas s odgovarajućim protivnicima na temelju razine vještine',
      item3: 'Pratimo vaš napredak, statistiku i postignuća',
      item4: 'Obrađujemo uplate za premium članstva i kozmetičke predmete',
      item5: 'Šaljemo važne službene objave i ažuriranja',
      item6: 'Analiziramo podatke o igranju kako bismo poboljšali ravnotežu igre i značajke',
    },

    thirdParty: {
      title: 'Usluge trećih strana',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Koristimo Firebase za autentifikaciju, pohranu baze podataka i funkcionalnost višeigrača. Firebase može prikupljati određene podatke kako je opisano u njihovoj politici privatnosti.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Koristimo Stripe za obradu uplata za premium članstva i kupnje u aplikaciji. Stripe rukuje svim informacijama o platnim karticama - nikada ne vidimo ili pohranjujemo vaše potpune podatke o plaćanju.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Naša web stranica je hostovana na Netlify-u, koji može prikupljati standardne podatke web hostinga poput IP adresa i zapisnika pristupa.',
      },
      adsense: {
        title: 'Google AdSense (Budućnost)',
        description: 'Možemo prikazivati oglase putem Google AdSense-a. Ti oglasi mogu koristiti kolačiće za personalizaciju. Za sadržaj usmjeren na djecu, pokazivat ćemo samo nepersonalizirane oglase u skladu s COPPA-om.',
      },
      viewPolicy: 'Pogledaj njihovu Politiku privatnosti',
    },

    cookies: {
      title: 'Kolačići i lokalna pohrana',
      description: 'Koristimo lokalnu pohranu preglednika (slično kolačićima) kako bismo poboljšali vaše iskustvo:',
      item1: 'Jezična preferencija: Pamtimo vaš odabrani jezik',
      item2: 'Sesija računa: Održavamo vas prijavljenim (radi s Firebase-om)',
      item3: 'Postavke igre: Pamtimo vaše UI preferencije i postavke testnog okruženja',
      item4: 'Oglašivački kolačići: Ako pristanete, usluge oglašavanja treće strane mogu koristiti kolačiće za personalizaciju oglasa',
    },

    security: {
      title: 'Sigurnost podataka',
      p1: 'Primjenjujemo odgovarajuće sigurnosne mjere za zaštitu vaših podataka:',
      item1: 'Enkripcija lozinke: Sve lozinke su enkriptirane koristeći industrijsko-standardne metode',
      item2: 'Sigurne veze: HTTPS enkripcija za sve prijenose podataka',
      item3: 'Firebase sigurnosna pravila: Stroga kontrola pristupa bazi podataka',
      p2: 'Međutim, nijedna metoda prijenosa preko interneta nije 100% sigurna. Iako težimo zaštiti vaših podataka, ne možemo jamčiti apsolutnu sigurnost.',
    },

    retention: {
      title: 'Zadržavanje podataka',
      p1: 'Zadržavamo vaše podatke na sljedeći način:',
      item1: 'Aktivni računi: Podaci se zadržavaju dok je vaš račun aktivan',
      item2: 'Neaktivni računi: Ako je vaš račun neaktivan 10 godina, možemo izbrisati vaše podatke',
    },

    rights: {
      title: 'Vaša prava privatnosti',
      description: 'Ovisno o vašoj lokaciji, možete imati sljedeća prava:',
      access: {
        title: 'Pristup:',
        description: 'Zatražiti kopiju svojih osobnih podataka',
      },
      correction: {
        title: 'Ispravak:',
        description: 'Zatražiti ispravke svojih podataka',
      },
      deletion: {
        title: 'Brisanje:',
        description: 'Zatražiti brisanje svog računa i podataka',
      },
      portability: {
        title: 'Prenosivost podataka:',
        description: 'Zatražiti svoje podatke u prenosivom formatu',
      },
      optOut: {
        title: 'Odjava:',
        description: 'Odjaviti se od marketinških komunikacija',
      },
      contact: 'Da biste ostvarili bilo koje od ovih prava, molimo vas da nas kontaktirate na contact@zodiac-chess.com',
    },

    international: {
      title: 'Međunarodni korisnici',
      p1: 'Zodiac Chess se vodi iz Novog Zelanda. Ako pristupate našoj usluzi izvan Novog Zelanda, molimo vas da budete svjesni da se vaši podaci mogu prenijeti, pohraniti i obraditi na Novom Zelandu i drugim zemljama gdje djeluju naši pružatelji usluga.',
      p2: 'Korištenjem naše usluge pristajete na prijenos vaših podataka u zemlje izvan vaše zemlje prebivališta, koje mogu imati različite zakone o zaštiti podataka.',
    },

    changes: {
      title: 'Promjene ove Politike privatnosti',
      description: 'Možemo s vremena na vrijeme ažurirati ovu Politiku privatnosti. Obavijestit ćemo vas o svim promjenama objavljivanjem nove Politike privatnosti na ovoj stranici i ažuriranjem datuma "Zadnje ažurirano". Značajne promjene bit će komunicirane putem e-maila ili istaknute obavijesti na našoj web stranici.',
    },

    contact: {
      title: 'Kontaktirajte nas',
      description: 'Ako imate bilo kakvih pitanja, nedoumica ili zahtjeva u vezi s ovom Politikom privatnosti ili našim praksama podataka, molimo vas da nas kontaktirate:',
      email: 'Email:',
      company: 'Tvrtka:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Uvjeti korištenja',
    lastUpdated: 'Zadnje ažuriranje',
    back: 'Natrag',
    viewPrivacyPolicy: 'Pogledaj Politiku privatnosti',
    acknowledgment: 'Korištenjem Zodiac Chessa potvrđujete da ste pročitali, razumjeli i pristajete biti obvezani ovim Uvjetima korištenja.',
    acceptance: {
      title: '1. Prihvaćanje uvjeta',
      p1: 'Pristupanjem i korištenjem Zodiac Chessa ("Usluga") prihvaćate i pristajete biti obvezani ovim Uvjetima korištenja. Ako se ne slažete s ovim uvjetima, molimo vas da ne koristite Uslugu.',
      p2: 'Zadržavamo pravo izmjene ovih uvjeta u bilo kojem trenutku. Nastavak korištenja Usluge nakon promjena predstavlja prihvaćanje izmijenjenih uvjeta.',
    },
    description: {
      title: '2. Opis usluge',
      p1: 'Zodiac Chess je online strateška igra na ploči s jedinstvenim životinjskim figurama s posebnim sposobnostima. Usluga uključuje:',
      feature1: 'Igru za jednog igrača protiv AI protivnika',
      feature2: 'Multiplayer uparivanje i natjecateljsku igru',
      feature3: 'Interaktivne tutorijale i resurse za učenje',
      feature4: 'Kreiranje računa i praćenje napretka',
      feature5: 'Opcionalne premium značajke pretplate',
      feature6: 'Opcije kozmetičke prilagodbe',
    },
    accounts: {
      title: '3. Korisnički računi',
      eligibility: {
        title: '3.1 Prihvatljivost',
        p1: 'Morate imati najmanje 13 godina da biste kreirali račun. Korisnici mlađi od 13 godina mogu koristiti način igre za goste uz roditeljski nadzor, ali ne mogu kreirati račune.',
      },
      responsibilities: {
        title: '3.2 Sigurnost računa',
        p1: 'Vi ste odgovorni za:',
        item1: 'Održavanje povjerljivosti vaše lozinke',
        item2: 'Sve aktivnosti koje se odvijaju pod vašim računom',
        item3: 'Trenutno obavještavanje nas o bilo kakvoj neovlaštenoj upotrebi',
        p2: 'Nismo odgovorni za bilo kakav gubitak ili štetu nastalu zbog neovlaštenog pristupa računu.',
      },
      prohibited: {
        title: '3.3 Zabranjene aktivnosti',
        p1: 'NE smijete:',
        item1: 'Dijeliti svoj račun s drugima',
        item2: 'Koristiti više računa za manipulaciju rangiranjem',
        item3: 'Koristiti botove, skripte ili automatizirane alate za igranje',
        item4: 'Uznemiravati, zlostavljati ili prijetiti drugim igračima',
        item5: 'Iskorištavati bugove ili greške za nepoštenu prednost',
        item6: 'Reverzno inženjerirati ili pokušati pristupiti našem izvornom kodu',
        p2: 'Kršenje ovih pravila može rezultirati suspenzijom računa ili trajnom zabranom.',
      },
    },
    premium: {
      title: '4. Premium pretplate',
      billing: {
        title: '4.1 Naplata',
        p1: 'Premium pretplate se obrađuju putem Stripea. Kupnjom premium pretplate ovlašćujete nas da naplaćujemo vašu metodu plaćanja na ponavljajućoj osnovi dok ne otkažete.',
        p2: 'Naknade za pretplatu su:',
        item1: 'Mjesečni plan: Naplaćuje se mjesečno na godišnjicu datuma kupnje',
        item2: 'Godišnji plan: Naplaćuje se godišnje na godišnjicu datuma kupnje',
        p3: 'Cijene se mogu promijeniti uz 30 dana obavijesti aktivnim pretplatnicima.',
      },
      cancellation: {
        title: '4.2 Otkazivanje',
        p1: 'Možete otkazati pretplatu u bilo kojem trenutku putem postavki računa ili kontaktiranjem podrške. Otkazivanje stupa na snagu na kraju vašeg trenutnog razdoblja naplate.',
        p2: 'Zadržat ćete premium značajke do kraja vašeg plaćenog razdoblja, čak i nakon otkazivanja.',
      },
      refunds: {
        title: '4.3 Povrati',
        p1: 'Mjesečne pretplate: Nema povrata za djelomične mjesece. Otkažite bilo kada da zaustavite buduće naplate.',
        p2: 'Godišnje pretplate: Puni povrat ako se zatraži unutar 7 dana od kupnje. Nakon 7 dana, povrati su prema našoj diskreciji.',
        p3: 'Kozmetičke kupnje: Općenito se ne vraćaju. Kontaktirajte podršku za iznimne okolnosti.',
      },
    },
    acceptable: {
      title: '5. Politika prihvatljive upotrebe',
      p1: 'Pristajete koristiti Zodiac Chess na pristojan i zakonit način. Zabranjeno ponašanje uključuje:',
      item1: 'Varanje, hakiranje ili iskorištavanje mehanika igre',
      item2: 'Uznemiravanje, govor mržnje ili diskriminatorni jezik',
      item3: 'Spamanje, oglašavanje ili nametanje',
      item4: 'Dijeljenje neprikladnog sadržaja (ako je chat ili sadržaj korisnika omogućen)',
      item5: 'Lažno predstavljanje kao drugi korisnici ili članovi osoblja',
      item6: 'Pokušaj ometanja ili oštećenja Usluge',
      p2: 'Zadržavamo pravo istraživanja kršenja i poduzimanja odgovarajućih mjera, uključujući ukidanje računa i prijavu nadležnim tijelima ako je potrebno.',
    },
    intellectual: {
      title: '6. Prava intelektualnog vlasništva',
      ownership: {
        title: '6.1 Naš sadržaj',
        p1: 'Sav sadržaj igre, uključujući, ali ne ograničavajući se na mehanike igre, umjetnička djela, animacije, zvučne efekte, kod i dizajn, u vlasništvu je Animal Chess Limited ili naših davatelja licenci.',
        p2: 'Dobivate ograničenu, neekskluzivnu, neprenosivu licencu za korištenje Usluge samo u svrhe osobne zabave.',
      },
      userContent: {
        title: '6.2 Korisnički sadržaj',
        p1: 'Slanjem sadržaja (poput chat poruka, korisničkih imena ili informacija profila), dajete nam svjetsku licencu bez naknade za korištenje, prikazivanje i distribuciju tog sadržaja u vezi s Uslugom.',
        p2: 'Izjavljujete da ste vlasnik ili imate potrebna prava na bilo koji sadržaj koji šaljete.',
      },
    },
    disclaimers: {
      title: '7. Odricanja od odgovornosti i ograničenja odgovornosti',
      p1: 'USLUGA SE PRUŽA "KAKVA JEST" BEZ IKAKVIH JAMSTAVA, BILO IZRIČITIH ILI IMPLICIRANIH.',
      p2: 'Ne jamčimo da će:',
      item1: 'Usluga biti neprekidna ili bez grešaka',
      item2: 'Nedostaci biti ispravljeni',
      item3: 'Usluga biti bez virusa ili štetnih komponenti',
      item4: 'Rezultati korištenja Usluge ispuniti vaša očekivanja',
      p3: 'U NAJVEĆOJ MJERI DOPUŠTENOJ ZAKONOM, NISMO ODGOVORNI ZA:',
      item5: 'Bilo kakvu neizravnu, slučajnu ili posljedičnu štetu',
      item6: 'Gubitak dobiti, podataka ili ugleda',
      item7: 'Prekide usluge ili gubitak podataka',
      item8: 'Štete koje premašuju iznos koji ste nam platili u posljednjih 12 mjeseci',
    },
    privacy: {
      title: '8. Privatnost',
      p1: 'Vaše korištenje Usluge također je regulirano našom Politikom privatnosti, koja objašnjava kako prikupljamo, koristimo i štitimo vaše osobne podatke.',
      p2: 'Korištenjem Usluge pristajete na naše prakse vezane uz podatke kako je opisano u Politici privatnosti.',
    },
    changes: {
      title: '9. Promjene uvjeta',
      p1: 'Zadržavamo pravo izmjene ovih Uvjeta korištenja u bilo kojem trenutku. Korisnike ćemo obavijestiti o značajnim promjenama putem:',
      item1: 'Obavijesti e-poštom registriranim korisnicima',
      item2: 'Istaknutog obavještenja na web stranici',
      item3: 'Ažuriranog datuma "Zadnje ažuriranje" na vrhu ove stranice',
      p2: 'Vaš nastavak korištenja Usluge nakon promjena predstavlja prihvaćanje izmijenjenih uvjeta.',
    },
    governing: {
      title: '10. Mjerodavno pravo',
      p1: 'Ovi Uvjeti korištenja regulirani su zakonima Novog Zelanda, bez obzira na načela sukoba zakona.',
      p2: 'Svi sporovi koji proizlaze iz ovih uvjeta ili vašeg korištenja Usluge rješavat će se pred sudovima Novog Zelanda.',
    },
    contact: {
      title: '11. Kontakt informacije',
      p1: 'Za pitanja, nedoumice ili podršku vezanu uz ove Uvjete korištenja:',
      email: 'E-pošta:',
      company: 'Tvrtka:',
      address: 'Adresa:',
    },
    severability: {
      title: '12. Odvojivost',
      p1: 'Ako se bilo koja odredba ovih uvjeta utvrdi neprovedivom ili nevažećom, ta će odredba biti ograničena ili uklonjena u najmanjoj potrebnoj mjeri, a preostale odredbe ostat će u punoj snazi i učinku.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Pravila o kolačićima',
    lastUpdated: 'Zadnje ažuriranje',
    browserInstructions: {
      chrome: 'Postavke → Privatnost i sigurnost → Kolačići',
      firefox: 'Postavke → Privatnost i sigurnost → Kolačići i podaci stranica',
      safari: 'Postavke → Privatnost → Kolačići i podaci web stranica',
      edge: 'Postavke → Privatnost, pretraživanje i usluge → Kolačići',
    },
    cookieTable: {
      name: 'Naziv kolačića',
      purpose: 'Svrha',
      duration: 'Trajanje',
      type: 'Vrsta',
    },
    relatedPolicies: {
      title: 'Povezana pravila',
      description: 'Za više informacija o tome kako postupamo s vašim podacima, molimo pogledajte:',
      privacy: 'Pravila o privatnosti',
      terms: 'Uvjeti korištenja',
    },

    introduction: {
      title: 'Uvod',
      p1: 'Ova Pravila o kolačićima objašnjavaju kako Zodiac Chess ("mi," "naš") koristi kolačiće i slične tehnologije kada posjetite našu web stranicu.',
      p2: 'Korištenjem naše web stranice pristajete na naše korištenje kolačića u skladu s ovim pravilima. Ako se ne slažete, molimo onemogućite kolačiće u postavkama preglednika ili nemojte koristiti našu web stranicu.',
    },
    what: {
      title: 'Što su kolačići?',
      p1: 'Kolačići su male tekstualne datoteke koje se postavljaju na vaš uređaj (računalo, pametni telefon, tablet) kada posjetite web stranicu. Naširoko se koriste kako bi web stranice radile učinkovito i pružale informacije vlasnicima web stranica.',
      p2: 'Kolačići služe različitim svrhama, uključujući pamćenje vaših preferencija, analizu korištenja stranice i omogućavanje određenih značajki.',
    },
    types: {
      title: 'Vrste kolačića koje koristimo',
      necessary: {
        title: '1. Nužni kolačići',
        description: 'Ovi kolačići su neophodni za pravilno funkcioniranje web stranice. Bez ovih kolačića, usluge koje ste zatražili ne mogu se pružiti.',
        examples: 'Primjeri:',
        item1: 'Autentifikacijski kolačići - Održavaju vas prijavljenima na vaš račun',
        item2: 'Sigurnosni kolačići - Štite od prijevarnih aktivnosti',
        item3: 'Kolačići sesije - Održavaju stanje vaše igre tijekom sesije',
        item4: 'Postavke pristanka za kolačiće - Pamte vaše izbore kolačića',
      },
      analytics: {
        title: '2. Analitički kolačići',
        description: 'Ovi kolačići nam pomažu razumjeti kako posjetitelji komuniciraju s našom web stranicom prikupljanjem anonimnih informacija o posjetima stranica, provedenom vremenu i korištenim značajkama.',
        provider: 'Pružatelj: Firebase Analytics (Google)',
        purpose: 'Svrha:',
        item1: 'Mjerenje prometa web stranice i angažmana korisnika',
        item2: 'Identificiranje popularnih značajki i stranica',
        item3: 'Razumijevanje demografije korisnika (dobna skupina, opća lokacija)',
        item4: 'Poboljšanje performansi web stranice i korisničkog iskustva',
      },
      advertising: {
        title: '3. Oglašivački kolačići',
        description: 'Ovi kolačići koriste se za prikazivanje oglasa koji su vam relevantni. Također ograničavaju broj puta koliko vidite oglas i pomažu mjeriti učinkovitost oglašivačkih kampanja.',
        provider: 'Pružatelj: Google AdSense',
        purpose: 'Svrha:',
        item1: 'Prikazivanje personaliziranih oglasa na temelju vaših interesa',
        item2: 'Mjerenje performansi oglasa i angažmana',
        item3: 'Sprječavanje preučestalog prikazivanja istog oglasa',
        note: 'Napomena: Premium pretplatnici nikada ne vide oglase, bez obzira na postavke kolačića.',
      },
    },
    firstThird: {
      title: 'Kolačići prve strane naspram kolačića treće strane',
      firstParty: {
        title: 'Kolačići prve strane',
        description: 'To su kolačići koje postavlja izravno Zodiac Chess. Koristimo ih za osnovnu funkcionalnost stranice, autentifikaciju i pamćenje vaših preferencija.',
      },
      thirdParty: {
        title: 'Kolačići treće strane',
        description: 'To su kolačići koje postavljaju vanjske usluge koje koristimo, kao što su Google Analytics i Google AdSense. Kolačići treće strane podliježu pravilima o privatnosti tih pružatelja.',
      },
    },
    specific: {
      title: 'Specifični kolačići koje koristimo',
      tableHeader: 'Ispod je detaljan popis kolačića koji se koriste na našoj web stranici:',
    },
    control: {
      title: 'Kako kontrolirati kolačiće',
      consent: {
        title: '1. Banner za pristanak na kolačiće',
        description: 'Kada prvi put posjetite našu web stranicu, vidjet ćete banner za pristanak na kolačiće. Možete:',
        item1: 'Prihvati sve - Dopusti sve kolačiće (nužne, analitičke i oglašivačke)',
        item2: 'Odbij neobavezne - Dopusti samo nužne kolačiće (bez analitike ili oglasa)',
        item3: 'Prilagodi - Odaberi točno koje vrste kolačića želiš dopustiti',
      },
      browser: {
        title: '2. Postavke preglednika',
        description: 'Većina web preglednika vam omogućuje kontrolu kolačića putem njihovih postavki. Možete:',
        item1: 'Blokirati sve kolačiće',
        item2: 'Prihvatiti samo kolačiće prve strane',
        item3: 'Brisati kolačiće nakon svake sesije pregledavanja',
        item4: 'Pregledati i brisati pojedinačne kolačiće',
        links: 'Ovdje su linkovi za upravljanje kolačićima za popularne preglednike:',
      },
      optOut: {
        title: '3. Alati za odjavu',
        description: 'Za oglašivačke kolačiće posebno, možete se odjaviti od personaliziranih oglasa:',
        googleLink: 'Google postavke oglasa',
        googleDesc: ' - Upravljajte personaliziranim Google oglasima',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Odjava od oglašavanja temeljenog na interesima',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Alat za odjavu specifičan za EU',
      },
    },
    impact: {
      title: 'Utjecaj onemogućavanja kolačića',
      p1: 'Ako onemogućite ili odbijete kolačiće, molimo imajte na umu da:',
      item1: 'Neki dijelovi web stranice možda neće ispravno funkcionirati',
      item2: 'Možda ćete morati ponovno unijeti svoje preferencije pri svakom posjetu',
      item3: 'Možete biti odjavljeni s vašeg računa',
      item4: 'Nužni kolačići su potrebni za rad stranice - njihovo onemogućavanje će vam spriječiti korištenje osnovnih značajki',
    },
    updates: {
      title: 'Ažuriranja ovih Pravila o kolačićima',
      p1: 'Ova Pravila o kolačićima možemo ažurirati s vremena na vrijeme kako bismo odrazili promjene u našim praksama ili iz pravnih, regulatornih ili operativnih razloga.',
      p2: 'Obavijestit ćemo vas o značajnim promjenama ažuriranjem datuma "Zadnje ažuriranje" na vrhu ove stranice. Molimo povremeno pregledajte ova pravila.',
    },
    contact: {
      title: 'Kontaktirajte nas',
      p1: 'Ako imate pitanja o našem korištenju kolačića ili ovim Pravilima o kolačićima, molimo kontaktirajte nas:',
      email: 'E-pošta:',
      company: 'Tvrtka:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pingvin',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Medvjed',
    Crane: 'Ždral',
    Frog: 'Žaba',
    Fungi: 'Gljiva',
    Goat: 'Koza',
    Monkey: 'Majmun',
    Octopus: 'Hobotnica',
    Penguin: 'Pingvin',
    Rhino: 'Nosorog',
    Snake: 'Zmija',
    Tree: 'Drvo',
    Virus: 'Virus',
    Wolf: 'Vuk',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
